import "./journal-section-six.scss";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Button, DatePicker, Table } from "antd";
import type { Dayjs } from "dayjs";
import { useForm, Controller } from "react-hook-form";
import { journalsQueries } from "@/entities/journal";
import {
  JournalSectionWrapper,
  JournalSectionActions,
  JournalSectionContent,
  JournalSectionHeader,
  JournalSectionDescription,
  JournalSectionFilters,
  JournalsResponsibleTable,
  type IJournalSectionHeaderAction,
} from "@/entities/journal/ui";
import {
  PlusIconBlack,
} from "@/shared/assets/svg/icons";
import { useCoordinator, useNavigationPosition } from "@/shared/lib/hooks";
import { InputSearch } from "@shared/ui";
import { getColumns, getDataSource } from "../../model";
import { JournalSectionSixInfo } from "../journal-section-info";

interface IFilterForm {
  search: string;
  addDate: [Dayjs | null, Dayjs | null] | null,
  actionDate: [Dayjs | null, Dayjs | null] | null,
  expirationDate: [Dayjs | null, Dayjs | null] | null,
  infactExpiration: [Dayjs | null, Dayjs | null] | null,
}

export const JournalSectionSix = () => {
  const { mainJournalId } = useCoordinator();
  const { isInJournalVersionSection } = useNavigationPosition();
  const [isModalInfoOpen, setIsModalInfoOpen] = useState(false);
  const [selectedItemData, setSelectedItemData] = useState<any>(null);
  const { control, watch } = useForm<IFilterForm>({
    defaultValues: {
      search: "",
      addDate: null,
      actionDate: null,
      expirationDate: null,
      infactExpiration: null,
    },
  });

  // Отслеживаем изменения в форме
  const formValues = watch();

  const { data: mainJournalData } = useQuery(
    journalsQueries.getJournal({ mainJournalId }),
  );

  const actionsList: IJournalSectionHeaderAction[] | undefined = [
  ];

  // Функция для форматирования даты в строку
  // const formatDateRange = (dateRange: [Dayjs | null, Dayjs | null] | null): string => {
  //   if (!dateRange || !dateRange[0] || !dateRange[1]) return "";
  //   return `${dateRange[0].format("YYYY-MM-DD")},${dateRange[1].format("YYYY-MM-DD")}`;
  // };


  const { data: sectionSixData, refetch: refetchSectionSix, isFetching } = useQuery(
    journalsQueries.getSection6({ 
      sectionSixListId: mainJournalData?.mainJournal?.section6?.sectionListId || "",
      search: formValues.search || "",
      page: 1,
      limit: 10,
    }),
  );

  // Приводим к правильному типу для использования в пагинации
  const typedSectionSixData = sectionSixData as any;

  return (
    <>
          <JournalsResponsibleTable
          sectionSixId={mainJournalData?.mainJournal?.section6?.sectionId || ""}
          type="sectionSix"
          />  
      <JournalSectionWrapper>
        <JournalSectionHeader actionsList={actionsList}>
          Раздел 6
        </JournalSectionHeader>
        <JournalSectionDescription>
        Сведения о государственном строительном надзоре при строительстве, реконструкции объекта капитального строительства
        </JournalSectionDescription>
        {!isInJournalVersionSection && (
          <JournalSectionActions>
            <Button type="primary" loading={isFetching} onClick={() => refetchSectionSix()}>
              Обновить
            </Button>
          </JournalSectionActions>
        )}
        <JournalSectionFilters className="journal-section-filters--space-between">
          <Controller
            name="search"
            control={control}
            render={({ field }) => (
              <InputSearch
                style={{ width: "25%", fontSize: "12px" }}
                {...field}
              />
            )}
          />
          <div
            className="journal-section-six-filters-group"
          >
            <div className="journal-section-six-filters-label">
              Фильтрация
            </div>
            <Controller
              name="addDate"
              control={control}
              render={({ field: { onChange, value, ...field } }) => (
                <DatePicker
                  {...field}
                  className="six-picker-classname"
                  value={value}
                  onChange={onChange}
                  placeholder="Дата добавления записи"
                  style={{ width: "210px", marginRight: "8px" }}
                  allowClear
                  format="DD.MM.YYYY"
                  suffixIcon={<PlusIconBlack />}
                />
              )}
            />
            <Controller
              name="actionDate"
              control={control}
              render={({ field: { onChange, value, ...field } }) => (
                <DatePicker
                  {...field}
                  value={value}
                  className="six-picker-classname"
                  onChange={onChange}
                  placeholder="Дата мероприятия"
                  style={{ width: "170px", marginRight: "8px" }}
                  allowClear
                  format="DD.MM.YYYY"
                  suffixIcon={<PlusIconBlack />}
                />
              )}
            />
            <Controller
              name="expirationDate"
              control={control}
              render={({ field: { onChange, value, ...field } }) => (
                <DatePicker
                  {...field}
                  className="six-picker-classname"
                  value={value}
                  onChange={onChange}
                  placeholder="Срок устранения"
                  style={{ width: "160px", marginRight: "8px" }}
                  allowClear
                  format="DD.MM.YYYY"
                  suffixIcon={<PlusIconBlack />}
                />
              )}
            />
            
            <Controller
              name="infactExpiration"
              control={control}
              render={({ field: { onChange, value, ...field } }) => (
                <DatePicker
                  {...field}
                  className="six-picker-classname"
                  value={value}
                  onChange={onChange}
                  placeholder="Фактическая дата устранения"
                  style={{ width: "250px", marginRight: "8px" }}
                  allowClear
                  format="DD.MM.YYYY"
                  suffixIcon={<PlusIconBlack />}
                />
              )}
            />

          </div>
        </JournalSectionFilters>
        <JournalSectionContent>
          <Table
            // @ts-expect-error типы колонок таблицы не совпадают с ColumnsType
            columns={getColumns({ 
              handleView: (record: any) => {
                setSelectedItemData(record);
                setIsModalInfoOpen(true);
              },
            })}
            dataSource={getDataSource(typedSectionSixData)}
            pagination={{
              total: typedSectionSixData?.total || 0,
              current: typedSectionSixData?.page || 1,
              pageSize: typedSectionSixData?.limit || 10,
              showSizeChanger: true,
              pageSizeOptions: ["5", "10", "20", "50", "100"],
              onChange: () => {
                // TODO: Добавить логику для изменения страницы
              },
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} из ${total} записей`,
            }}
          />
        </JournalSectionContent>
      </JournalSectionWrapper>
      {isModalInfoOpen && (
        <JournalSectionSixInfo
          itemData={selectedItemData}
          handleClose={() => {
            setIsModalInfoOpen(false);
            setSelectedItemData(null);
          }}
        />
      )}
    </>
  );
};
